import { useState } from 'react';
import { View } from 'react-native';
import { Text } from '@ui-kitten/components';

import { ByLineProps } from './types';

const ReadMoreByLine = ({
  category = 'p1',
  contentContainerStyle,
  lineHeight = 23,
  maxLine,
  status = 'success',
  value,
}: ByLineProps) => {
  const [readMore, setReadMore] = useState(false);
  const [showButtonReadMore, setShowButtonReadMore] = useState(false); //To show ur remaining Text
  const [lineNumber, setNumberOfLines] = useState(undefined);
  const readMoreBtnTxt = showButtonReadMore ? 'Show less' : 'Show more';

  const toggleReadMoreButton = () => setShowButtonReadMore(!showButtonReadMore);

  const onLayout = (e) => {
    const limitHeight = maxLine * lineHeight; //get the limit height
    const currentHeight = e.nativeEvent.layout.height; //get the current height
    if (currentHeight > limitHeight) {
      //if the value has more data than to set to limit height then set the line numner and show the read more button
      setNumberOfLines(maxLine);
      setReadMore(true);
      return;
    }
  };

  if (!value) return null;

  return (
    <View style={contentContainerStyle}>
      <Text
        onLayout={onLayout}
        numberOfLines={showButtonReadMore ? undefined : lineNumber}
        category={category}
        style={{ lineHeight: lineHeight }}
      >
        {value}
      </Text>
      {readMore && (
        <Text
          category={category}
          status={status}
          onPress={toggleReadMoreButton}
          style={{ lineHeight: lineHeight }}
        >
          {readMoreBtnTxt}
        </Text>
      )}
    </View>
  );
};

export default ReadMoreByLine;
